import React, { useRef, useState } from "react";

import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, IconButton } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import dayjs from "dayjs";

import {
  designationsCellRenderer,
  setDesignations,
  setEmployeeTypes,
  setMaritalStatuses,
  setUsers,
  userCellRenderer,
} from "../../../../component/cellRenderers/renderers";
import SideNav from "../../../../component/layouts/sideNav";
import {
  setAlertConfirmDeletion,
  setAlertTitleText,
} from "../../../../component/modal/alertModal";

import {
  PRUSSIAN_BLUE,
  SPANISH_GREEN,
  WHITE,
} from "../../../../resources/constant/colors/theme";
import {
  ADD,
  DELETE,
  EMPLOYEE,
  MASTER,
} from "../../../../resources/constant/strings/string";
import { PATH_ADD_EMPLOYEE } from "../../../../resources/constant/url/url";

import { APIMASTER } from "../../../../apihandler/master";

import Modal from "./modal";

export default function AddEmployee() {
  const gridRef = useRef();

  const [selectedRowId, setSelectedRowId] = useState(0);
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  let initialValue = {};

  const setInitialValueForAdd = () => {
    initialValue = {
      id: 0,
      employeeNo: "Auto Generated",
      firstName: "",
      lastName: "",
      designationId: 0,
      gender: "",
      dateOfBirth: dayjs("02-02-2002"),
      dateOfJoining: dayjs("02-02-2022"),
      maritalStatusId: "",
      bloodGroup: "",
      employmentStatus: "",
      employmentTypeId: 0,
    };
  };

  const deleteModel = () => {
    if (selectedRowIds.length === 0) {
      return;
    }
    setAlertConfirmDeletion(
      "Confirmation needed",
      `Do you confirm on proceeding to delete ${selectedRowIds.length} record(s)?`
    ).then((consent) => {
      if (!consent.isConfirmed) return;

      console.log("delete the selected ids: ", selectedRowIds);
      APIMASTER.DeleteEmployees(selectedRowIds)
        .then((resp) => resp.json())
        .then((data) => {
          if (data.statusCode === 204) {
            const selectedData = gridRef.current.api.getSelectedRows();
            gridRef.current.api.applyTransaction({ remove: selectedData });
            setAlertTitleText("Success", "The record was deleted successfully");
            setOpenModal(false);
          } else {
            setAlertTitleText(
              "Oops...",
              `Something went wrong...${data.message}`
            );
            setOpenModal(false);
          }
        });
    });
  };

  const updateModel = (model) => {
    gridRef.current.api.applyTransaction({ update: [model] });
  };

  const addModel = (model) => {
    gridRef.current.api.applyTransaction({ add: [model], addIndex: 0 });
  };

  const onRowSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    if (selectedRows.length > 0) {
      setSelectedRowId(selectedRows[0].id);
      const ids = selectedRows.map((row) => row.id);
      setSelectedRowIds(ids);
    } else {
      setSelectedRowId(0);
      setSelectedRowIds([]);
    }
  };
  const [formTitle, setFormTitle] = useState("Employee");
  const handleEditData = (oldData) => {
    console.log(oldData);
    initialValue = {
      id: oldData.id,
      employeeNo: oldData.employeeNo,
      firstName: oldData.firstName,
      lastName: oldData.lastName,
      designationId: oldData.designationId,
      gender: oldData.gender,
      dateOfBirth: oldData.dateOfBirth,
      dateOfJoining: oldData.dateOfJoining,
      maritalStatusId: oldData.maritalStatusId,
      bloodGroup: oldData.bloodGroup,
      employmentStatus: oldData.employmentStatus,
      employmentTypeId: oldData.employmentTypeId,
    };
    setFormData(initialValue);
    setViewOnlyModel(false);
    setFormTitle("Edit Employee");
    setOpenModal(true);
  };

  const handleViewData = (oldData) => {
    console.log(oldData);
    initialValue = {
      id: oldData.id,
      employeeNo: oldData.employeeNo,
      firstName: oldData.firstName,
      lastName: oldData.lastName,
      designationId: oldData.designationId,
      gender: oldData.gender,
      dateOfBirth: oldData.dateOfBirth,
      dateOfJoining: oldData.dateOfJoining,
      maritalStatusId: oldData.maritalStatusId,
      bloodGroup: oldData.bloodGroup,
      employmentStatus: oldData.employmentStatus,
      employmentTypeId: oldData.employmentTypeId,
    };
    setFormData(initialValue);
    setViewOnlyModel(true);
    setFormTitle("View Employee");
    setOpenModal(true);
  };

  const columnDefs = [
    {
      headerName: "Emp No",
      field: "employeeNo",
      checkboxSelection: false,
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "First Name",
      field: "firstName",
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
      wrapText: true,
      autoHeight: true,
    },
    {
      headerName: "Last Name",
      field: "lastName",
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
      wrapText: true,
      autoHeight: true,
    },
    {
      headerName: "Designation",
      field: "designationId",
      valueGetter: (params) => {
        return designationsCellRenderer({ value: params.data.designationId });
      },
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
      wrapText: true,
      autoHeight: true,
    },
    {
      headerName: "Joining Date",
      field: "dateOfJoining",
      filter: false,
      floatingFilter: false,
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Date Of Birth",
      field: "dateOfBirth",
      filter: "agTextColumnFilter",
      floatingFilter: false,
      cellStyle: {
        "text-align": "center",
        "border-right-color": "#e2e2e2",
      },
    },
    {
      headerName: "Modified By",
      field: "modifiedBy",
      valueGetter: (params) => {
        return userCellRenderer({ value: params.data.modifiedBy });
      },
      cellStyle: {
        "border-right-color": "#e2e2e2",
      },
      autoHeight: true,
      wrapText: true,
    },

    {
      flex: 0.8,
      headerName: "Actions",
      field: "id",
      sortable: false,
      filter: false,
      floatingFilter: false,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <IconButton
            aria-label="edit"
            onClick={() => {
              handleEditData(params.data);
            }}
          >
            <EditIcon style={{ color: PRUSSIAN_BLUE, width: "20px" }} />
          </IconButton>
          <IconButton
            aria-label="visibility"
            onClick={() => {
              handleViewData(params.data);
            }}
          >
            <VisibilityIcon style={{ color: PRUSSIAN_BLUE, width: "20px" }} />
          </IconButton>
        </div>
      ),
    },
  ];

  const defaultColDef = {
    resizable: true,
    sortable: true,
    editable: false,
    flex: 1,
    filter: "agTextColumnFilter",
    filterParams: {
      caseSensitive: false,
      defaultOption: "startsWith",
    },
    floatingFilter: true,
  };

  const onGridReady = (params) => {
    APIMASTER.DesignationOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        setDesignations(resp.response);
      });
    APIMASTER.EmployeeTypeOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        setEmployeeTypes(resp.response);
      });
    APIMASTER.MartialStatusOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        setMaritalStatuses(resp.response);
      });

    APIMASTER.UserOptions()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) return;

        setUsers(resp.response);
      });

    APIMASTER.Employees()
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.statusCode !== 200) {
          setAlertTitleText("Oops..", `An error occurred ${resp.message}`);
          return;
        }
        const data = resp.response.sort((a, b) => b.id - a.id);
        params.api.applyTransaction({ add: data });
      });
  };

  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState(initialValue);
  const [viewOnlyModel, setViewOnlyModel] = useState(false);

  return (
    <SideNav
      currentComponent={MASTER}
      subComponent={EMPLOYEE}
      subComponentPath={PATH_ADD_EMPLOYEE}
      detailComponent=""
    >
      {openModal && (
        <Modal
          style={{ align: "center" }}
          setOpenModal={setOpenModal}
          updateModel={updateModel}
          viewModel={viewOnlyModel}
          addModel={addModel}
          model={formData}
          formTitle={formTitle}
        ></Modal>
      )}
      <div
        style={{
          display: "flex",
          flexDirection: "row-reverse",
          marginBottom: 10,
          marginRight: 10,
        }}
      >
        <Button
          style={{
            backgroundColor: SPANISH_GREEN,
            textTransform: "capitalize",
            fontSize: 14,
            color: WHITE,
            minWidth: "180px",
            minHeight: "45px",
          }}
          onClick={() => {
            setInitialValueForAdd();
            setFormData(initialValue);
            setViewOnlyModel(false);
            setFormTitle("Add Employee");
            setOpenModal(true);
          }}
        >
          {ADD}
        </Button>

        <Button
          onClick={() => {
            deleteModel();
          }}
          variant="outlined"
          sx={{
            borderColor: SPANISH_GREEN,
          }}
          style={{
            //backgroundColor: SPANISH_GREEN,
            textTransform: "capitalize",
            fontSize: 14,
            color: SPANISH_GREEN,
            minWidth: "180px",
            minHeight: "45px",
            marginRight: 10,
          }}
        >
          {DELETE}
        </Button>
      </div>
      <div className="App">
        <div className="ag-theme-alpine" style={{ height: "570px" }}>
          <AgGridReact
            copyGroupHeadersToClipboard={true}
            enableRangeSelection={true}
            columnDefs={columnDefs}
            ref={gridRef}
            defaultColDef={defaultColDef}
            onGridReady={onGridReady}
            paginationAutoPageSize={true}
            pagination={true}
            rowSelection="multiple"
            getRowId={(params) => params.data.id}
            onSelectionChanged={onRowSelectionChanged}
          ></AgGridReact>
        </div>
      </div>
    </SideNav>
  );
}
